export const richHeroMedia = () => {
  const videos = [...document.querySelectorAll('[data-v4-rich-hero-responsive-video]')];
  if (!videos.length || !window.matchMedia) return;

  const portraitQuery = window.matchMedia('(orientation: portrait)');

  const syncVideo = (video) => {
    const sources = [...video.querySelectorAll('[data-v4-rich-hero-video-source]')];
    if (!sources.length) return;

    const orientation = portraitQuery.matches ? 'portrait' : 'landscape';
    let sourceChanged = false;

    sources.forEach((source) => {
      if (!source.dataset.src) source.dataset.src = source.getAttribute('src') || '';

      const isActive = source.dataset.v4RichHeroVideoOrientation === orientation;
      if (isActive && !source.hasAttribute('src') && source.dataset.src) {
        source.setAttribute('src', source.dataset.src);
        sourceChanged = true;
      } else if (!isActive && source.hasAttribute('src')) {
        source.removeAttribute('src');
        sourceChanged = true;
      }
    });

    if (sourceChanged) video.load();

    const hasActiveSource = sources.some((source) => source.hasAttribute('src'));
    if (!hasActiveSource) {
      video.pause();
      return;
    }

    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  };

  const syncVideos = () => videos.forEach(syncVideo);

  if (portraitQuery.addEventListener) {
    portraitQuery.addEventListener('change', syncVideos);
  } else {
    portraitQuery.addListener(syncVideos);
  }

  syncVideos();
};
